var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailConfirmed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 360,
    viewBox: "0 0 360 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1543_52279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.043 140.871L180 226.957L46.9569 140.871V7.82776C46.8652 3.59729 50.2204 0.093914 54.4508 0.00220244C54.5616 1.3657e-06 54.6724 1.3657e-06 54.7832 0.00220244H305.217C309.447 -0.0895091 312.951 3.26567 313.043 7.49613C313.045 7.60692 313.045 7.71771 313.043 7.8285V140.871Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9563 140.871L0 109.567L46.9563 62.6104V140.871Z",
    fill: "#EFCFB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.999 109.567L313.043 140.871V62.6104L359.999 109.567Z",
    fill: "#F9E0CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.044 140.167L360 109.567V328.696C359.985 336.997 356.695 344.956 350.844 350.844L297.392 297.393L211.305 211.306L209.113 207.94L313.044 140.167Z",
    fill: "#FEEBDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.39 297.392L350.842 350.844C344.954 356.695 336.995 359.985 328.694 360H31.3042C23.0032 359.985 15.0441 356.695 9.15625 350.844L62.6079 297.392L148.694 211.306L150.886 207.94L179.999 226.957L209.112 207.94L211.303 211.306L297.39 297.392Z",
    fill: "#EFCFB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.888 207.94L148.696 211.306L62.6101 297.392L9.15843 350.844C3.30724 344.956 0.016627 336.997 0.00195312 328.696V109.567L150.888 207.94Z",
    fill: "#FEEBDD"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1543_52279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180 265C214.242 265 242 237.242 242 203C242 168.758 214.242 141 180 141C145.758 141 118 168.758 118 203C118 237.242 145.758 265 180 265Z",
    fill: "#1AC057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242 203C242 237.1 214.1 265 180 265C160.238 265 142.8 256.088 131.562 241.75C142.025 250.275 155.588 255.313 170.312 255.313C204.413 255.313 232.313 227.413 232.313 193.313C232.313 178.588 227.275 165.025 218.75 154.563C233.088 165.8 242 183.237 242 203Z",
    fill: "#13A94A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.713 185.175L173.413 229.35C170.7 232.45 166.051 232.45 163.338 229.35L146.288 210.363C143.963 207.65 143.963 203.388 146.675 200.675C149.388 198.35 153.65 198.35 156.363 201.062L168.375 214.625L203.638 176.262C206.351 173.55 210.613 173.162 213.326 175.875C216.038 178.2 216.038 182.85 213.713 185.175Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1543_52279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 360,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1543_52279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    fill: "white",
    transform: "translate(118 141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailConfirmed);
export default __webpack_public_path__ + "static/media/email-confirmed.193112890de54b68c9c0199ed48c2168.svg";
export { ForwardRef as ReactComponent };